/**
 * Maqolalar reyestri.
 *
 * Kontent fayllari (`./<slug>.js`) `require.context` orqali avtomatik
 * topiladi — yangi fayl qo'shilsa, maqola o'zi paydo bo'ladi.
 * `POSTS` dagi tartib blog ro'yxatidagi tartibni belgilaydi.
 */

// slug — uz URL; ru — ruscha URL segmenti; date — ISO sana (sitemap uchun)
export const POSTS = [
    { slug: 'web-sayt', ru: 'web-sayt', date: '2026-01-15', cluster: 'web' },
    { slug: 'internetdokon', ru: 'internetdokon', date: '2026-01-22', cluster: 'ecommerce' },
    { slug: 'turlari', ru: 'turlari', date: '2026-02-03', cluster: 'web' },
    { slug: 'ai-ni-kichik-biznesga-joriy-etish', ru: 'vnedrenie-ii-v-malom-biznese', date: '2026-09-17', cluster: 'ai' },
    { slug: 'ai-chatbot-yoki-jonli-operator', ru: 'ai-chatbot-ili-zhivoy-operator', date: '2026-09-17', cluster: 'ai' },
    { slug: 'computer-vision-ombor-va-dokonda', ru: 'computer-vision-na-sklade-i-v-magazine', date: '2026-09-17', cluster: 'ai' },
    { slug: 'marketpleys-yoki-oz-internet-dokon', ru: 'marketpleys-ili-svoy-internet-magazin', date: '2026-09-17', cluster: 'ecommerce' },
    { slug: 'onlayn-tolov-ulash-payme-click', ru: 'podklyuchenie-onlayn-oplaty-payme-click', date: '2026-09-17', cluster: 'ecommerce' },
    { slug: 'internet-dokon-qonuniy-talablar-2026', ru: 'trebovaniya-zakona-k-internet-magazinu-2026', date: '2026-09-17', cluster: 'ecommerce' },
    { slug: 'marketpleys-va-sayt-sinxronizatsiya', ru: 'sinhronizaciya-marketpleysa-i-sayta', date: '2026-09-17', cluster: 'ecommerce' },
    { slug: 'biznes-avtomatlashtirish-yol-xaritasi', ru: 'avtomatizaciya-biznesa-dorozhnaya-karta', date: '2026-09-17', cluster: 'automation' },
    { slug: 'tayyor-crm-yoki-oz-crm-tco', ru: 'gotovaya-crm-ili-svoya-crm-tco', date: '2026-09-17', cluster: 'automation' },
    { slug: 'excel-dan-erp-ga-otish-signallari', ru: 'priznaki-perehoda-s-excel-na-erp', date: '2026-09-17', cluster: 'automation' },
    { slug: 'telegram-bot-nimani-avtomatlashtiradi', ru: 'chto-avtomatiziruet-telegram-bot', date: '2026-09-17', cluster: 'automation' },
    { slug: 'biznesni-raqamlashtirish-talablari-2026', ru: 'trebovaniya-cifrovizacii-biznesa-2026', date: '2026-09-17', cluster: 'compliance' },
    { slug: 'markirovka-kodi-chekda-2026', ru: 'kod-markirovki-v-cheke-2026', date: '2026-09-17', cluster: 'compliance' },
    { slug: 'ulgurji-savdo-naqdsiz-hisob-kitob', ru: 'optovaya-torgovlya-beznalichnyy-raschet', date: '2026-09-17', cluster: 'compliance' },
    { slug: 'shaxsiy-malumotlar-qonuni-sayt', ru: 'zakon-o-personalnyh-dannyh-i-sayt', date: '2026-09-17', cluster: 'compliance' },
    { slug: 'ozbekistonda-ikki-tilli-seo', ru: 'dvuyazychnoe-seo-v-uzbekistane', date: '2026-09-17', cluster: 'growth' },
    { slug: 'google-business-profil-yaqin-atrofda', ru: 'google-business-profil-ryadom-so-mnoy', date: '2026-09-17', cluster: 'growth' },
    { slug: 'ariza-tannarxi-seo-ads-instagram', ru: 'stoimost-zayavki-seo-ads-instagram', date: '2026-09-17', cluster: 'growth' },
    { slug: 'oz-dasturchisi-yoki-autsorsing', ru: 'svoy-razrabotchik-ili-autsorsing', date: '2026-09-17', cluster: 'economics' },
    { slug: 'it-park-rezidentligi-2026', ru: 'rezidentstvo-it-park-2026', date: '2026-09-17', cluster: 'economics' },
];

const ctx = require.context('./', false, /^\.\/(?!_|index)[a-z0-9-]+\.js$/);

const bySlug = ctx.keys().reduce((acc, key) => {
    const slug = key.replace('./', '').replace('.js', '');
    const mod = ctx(key);
    acc[slug] = mod.default || mod;
    return acc;
}, {});

/** Kontenti yozilgan maqolalargina */
export const PUBLISHED = POSTS.filter((p) => Boolean(bySlug[p.slug]));

/** @param {string} slug @param {'uz'|'ru'} lang */
export function getPost(slug, lang) {
    const entry = bySlug[slug];
    if (!entry) return null;
    return entry[lang] || entry.uz || null;
}

/** uz yoki ru slug bo'yicha topadi */
export function findPost(slug) {
    return POSTS.find((p) => p.slug === slug || p.ru === slug) || null;
}

/** @param {'uz'|'ru'} lang */
export function postPath(post, lang) {
    return lang === 'ru' ? `/ru/blog/${post.ru}` : `/blog/${post.slug}`;
}

export default POSTS;
